import React, { useRef, useState } from 'react';
import { FaCamera, FaSpinner } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { authService } from '../../../../services/apiService';
import { shelfListingService } from '../../../../services/shelfListingService';

export default function OemLabelCapture({ partName, grade, value, onChange, onDowngrade }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [attempt, setAttempt] = useState(1);

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const upload = await authService.uploadCompressedFile(file);
      const url = upload?.path || upload?.url || upload;

      const res = await shelfListingService.validateOemLabel({
        oemPhotoUrl: url,
        partName,
        attemptNumber: attempt,
      });

      if (res?.success) {
        onChange?.({ oemPhotoUrl: url, attempt });
        toast.success('OEM label verified');
        return;
      }

      const data = res?.data;
      if (data?.retakeAllowed && attempt < 2) {
        toast.warn(data.reason || 'Please retake the label photo');
        setAttempt(2);
        return;
      }

      onDowngrade?.({ message: data?.reason || 'Could not verify OEM label' });
    } catch (err) {
      toast.error(err?.message || 'Upload failed');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div className="rounded-lg border border-slate-200 p-4 bg-slate-50">
      <p className="text-sm font-semibold text-slate-800 mb-2">OEM label photo</p>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-600 text-white text-sm font-medium disabled:opacity-60"
      >
        {uploading ? <FaSpinner className="animate-spin" /> : <FaCamera />}
        {uploading ? 'Compressing & uploading…' : value ? 'Retake label photo' : 'Capture OEM label'}
      </button>
      {value && (
        <p className="text-xs text-emerald-700 mt-2">Label photo uploaded (attempt {attempt})</p>
      )}
      {grade && <p className="text-xs text-slate-500 mt-1">Grade: {grade}</p>}
    </div>
  );
}
